let dd = require("ES/lib/dd");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../utils/FormUtils");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let ezVerticalFields = require("react-loose-forms.bootstrap3/layouts/ezVerticalFields");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");

let DaForm = dd.createClass({
	mixins: [FormMixin],
	buildSchema(){
		return  {
			username: {
				type: "text",
				label: "Your username",
				placeholder: "Username",
				validate: FormUtils.v.required
			}
		};
	},
	render(){
		return dd.form({onSubmit: this.Form_onSubmit},
			ezVerticalFields(this),
			dd.div(null,
				dd.button({className: "btn btn-default btn-block"}, "Reset Password")
			)
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup(){
		return {
			Authenticate_forgotpassword: {key: "callService"}
		};
	},
	__onSubmit(data){
		this.RadioService_callService(
			"Authenticate_forgotpassword",
			data.username.toLowerCase().trim()
		);
	},
	render(){
		let ajax = this.state.Authenticate_forgotpassword;

		if(ajax.data){
			return dd.div({className: "alert alert-info"},
				ajax.data
			);
		}
		return dd.div(null,
			ErrorAlert({message: ajax.error}),
			LoadingWrap({is_loading: ajax.waiting, text: "Looking up and sending email..."},
				dd.h3({style: {margin: "10px 0 20px 0"}, className: "text-muted"},
					"Forgot Password"
				),
				DaForm({onSubmit: this.__onSubmit})
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/signin/ForgotForm.js